import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

interface ExportData {
  title: string;
  description: string;
  results: { label: string; value: string; color?: string }[];
  footerLink?: string;
}

export const exportToPDF = ({ title, description, results, footerLink = 'https://www.calculadora.dev.br' }: ExportData) => {
  console.log('Iniciando exportação PDF...', { title, resultsCount: results.length });

  try {
    // Inicializar documento com orientação retrato e unidade mm
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();

    // Cores da Marca (Tuplas de RGB)
    const colors: { primary: [number, number, number], slate: [number, number, number], emerald: [number, number, number] } = {
      primary: [79, 70, 229], // Indigo 600
      slate: [71, 85, 105],  // Slate 600
      emerald: [5, 150, 105], // Emerald 600
    };

    // Cabeçalho - Estilo Premium
    doc.setFillColor(colors.primary[0], colors.primary[1], colors.primary[2]);
    doc.rect(0, 0, pageWidth, 40, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(24);
    doc.text('Calculadora PRO', 20, 25);

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text('Relatório de Cálculo Profissional', pageWidth - 20, 25, { align: 'right' });

    // Título e Descrição
    doc.setTextColor(30, 41, 59); // Slate 900
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text(title, 20, 60);

    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(71, 85, 105); // Slate 600
    const splitDescription = doc.splitTextToSize(description, pageWidth - 40);
    doc.text(splitDescription, 20, 70);

    // Resultados usando autoTable como função (mais estável em ESM)
    if (typeof autoTable === 'function') {
      autoTable(doc, {
        startY: 85,
        head: [['Indicador', 'Valor']],
        body: results.map(r => [r.label, r.value]),
        theme: 'striped',
        headStyles: {
          fillColor: colors.primary,
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          halign: 'center'
        },
        columnStyles: {
          0: { fontStyle: 'bold', textColor: colors.slate },
          1: { halign: 'right', fontStyle: 'bold', textColor: colors.primary }
        },
        margin: { left: 20, right: 20 },
        styles: { font: 'helvetica', fontSize: 10, cellPadding: 6 }
      });
    } else {
      console.error('Plugin autoTable não encontrado. Tentando via protótipo...');
      const fallbackDoc = doc as any;
      if (typeof fallbackDoc.autoTable === 'function') {
        fallbackDoc.autoTable({
          startY: 85,
          head: [['Indicador', 'Valor']],
          body: results.map((r: any) => [r.label, r.value]),
          margin: { left: 20, right: 20 }
        });
      } else {
        throw new Error('Plugin jspdf-autotable não pôde ser inicializado.');
      }
    }

    // Rodapé em todas as páginas
    const pageCount = (doc as any).getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const y = doc.internal.pageSize.getHeight() - 15;

      doc.setDrawColor(226, 232, 240); // Slate 200
      doc.line(20, y - 5, pageWidth - 20, y - 5);

      doc.setFontSize(9);
      doc.setTextColor(148, 163, 184); // Slate 400
      doc.text(`Gerado por Calculadora PRO - ${footerLink}`, 20, y);
      doc.text(`Página ${i} de ${pageCount}`, pageWidth - 20, y, { align: 'right' });
    }

    // Nome do arquivo sanitizado para evitar problemas de download
    const fileName = `CalculadoraPRO_${title.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/gi, '_')}.pdf`;
    doc.save(fileName);
    console.log('PDF exportado com sucesso:', fileName);
  } catch (error) {
    console.error('Falha crítica na exportação do PDF:', error);
    alert('Ops! Ocorreu um erro ao gerar o relatório PDF. Verifique se o seu navegador não bloqueou o download.');
  }
};

export const shareToWhatsApp = (title: string, results: { label: string; value: string }[]) => {
  const siteUrl = 'https://www.calculadora.dev.br';
  let message = `*Calculadora PRO: ${title}*\n\n`;

  results.forEach(r => {
    message += `• *${r.label}:* ${r.value}\n`;
  });

  message += `\nCalcule você também em: ${siteUrl}`;

  const encodedText = encodeURIComponent(message);
  window.open(`https://wa.me/?text=${encodedText}`, '_blank');
};


